import { useIpc } from 'mypages-library';
import { useEffect } from 'react';

export const useConnectIpc = () => {
  const { beginSession, connect } = useIpc();
  const searchParams = new URLSearchParams(window.location.search);
  const runningInApp = Boolean(searchParams.get('mm_app'));
  const targetName = searchParams.get('target') || '';
  const currentPath = window.location.pathname;
  const earlyBeginTargets = ['accountinformation', 'webshop', 'webshopproduct', 'webshopbattery', 'webshopsms'];
  const externalPaths = ['/login/redirect', '/login/deeplink'];

  const connectIpcAsync = async () => {
    try {
      await connect();
      beginSession();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error connecting to IPC', error);
    }
  };

  useEffect(() => {
    const isCurrentPathExternal = externalPaths.includes(currentPath);

    if (runningInApp && (!isCurrentPathExternal || (isCurrentPathExternal && earlyBeginTargets.includes(targetName)))) {
      connectIpcAsync();
    }
  }, [runningInApp, targetName, currentPath]);
};
